<div class="grid">
	<div class="col-12">
		<div class="card">
			<p-divider></p-divider>
			<h4>Listagem de Tributação</h4>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="listaTributacaoEmpresa" dataKey="id" [rows]="10" [loading]="loading" [rowHover]="true"
				styleClass="p-datatable-gridlines" [paginator]="true" 
				[globalFilterFields]="['razaoSocial' , 'tipoRegistro']"
				responsiveLayout="scroll" styleClass=" p-datatable-sm">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<div></div>
						<div>
							<span class="p-input-icon-left">
								<i class="pi pi-search"></i>
								<input pInputText type="text" #filter (input)="buscar(dt1, $event)" placeholder="Buscar"
									class="w-full" />
							</span>
							<span class="ml-2">
								<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
									pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
							</span>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="razaoSocial">
							Razão Social
							<p-sortIcon field="razaoSocial">
							</p-sortIcon>
						</th>
						<th pSortableColumn="cnpj">
							CNPJ
							<p-sortIcon field="cnpj">
							</p-sortIcon>
						</th>
						<th pSortableColumn="tipoRegistro">
							Tipo de Emissão
							<p-sortIcon field="tipoRegistro">
							</p-sortIcon>
						</th>
						
						<th *ngIf="!modoDetalhar">
							<div>
								Ações
							</div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td>
							{{ item.razaoSocial }}
						</td>
						<td>
							{{ item.cnpj | cnpjFormat }}
						</td>

						<td>
							{{ item.tipoRegistro }}
						</td>
					
						<td *ngIf="!modoDetalhar">
							<button pButton pRipple pTooltip="Editar" (click)="editarPermissao(item.id)"
								icon="pi pi-pencil" class="p-button-success mr-2 mb-2"></button>
						</td>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando fabricantes. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>